var _path, _path2, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "APP_STORE",
    "data-name": "APP STORE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.281,
    height: 35.639,
    viewBox: "0 0 120.281 35.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M116,35.639H4.213A4.223,4.223,0,0,1,0,31.422V4.211A4.217,4.217,0,0,1,4.213,0H116a4.275,4.275,0,0,1,4.279,4.211V31.422A4.281,4.281,0,0,1,116,35.639Z",
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M119.516,31.52a3.412,3.412,0,0,1-3.416,3.412H4.31A3.417,3.417,0,0,1,.89,31.52V4.307A3.421,3.421,0,0,1,4.31.89H116.1a3.416,3.416,0,0,1,3.416,3.417V31.52Z",
    transform: "translate(-0.097 -0.097)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(11.397 5.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M28.238,18.976a5.165,5.165,0,0,1,2.46-4.334,5.29,5.29,0,0,0-4.166-2.252c-1.753-.184-3.453,1.049-4.345,1.049-.911,0-2.285-1.031-3.767-1a5.547,5.547,0,0,0-4.669,2.848c-2.019,3.5-.513,8.632,1.421,11.457.968,1.384,2.1,2.929,3.578,2.874,1.448-.06,1.989-.923,3.736-.923,1.731,0,2.239.923,3.748.888,1.554-.025,2.532-1.39,3.466-2.786a11.433,11.433,0,0,0,1.585-3.228A4.993,4.993,0,0,1,28.238,18.976Z",
    transform: "translate(-12.792 -6.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M26.511,9.86a5.084,5.084,0,0,0,1.164-3.643,5.179,5.179,0,0,0-3.348,1.732,4.838,4.838,0,0,0-1.194,3.509A4.277,4.277,0,0,0,26.511,9.86Z",
    transform: "translate(-13.916 -6.217)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(37.786 16.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M52.42,30.053H50.4L49.288,26.57H45.436L44.38,30.053H42.41L46.227,18.2h2.358Zm-3.466-4.944-1-3.1q-.159-.474-.6-2.234h-.036q-.175.756-.563,2.234l-.985,3.1Z",
    transform: "translate(-42.41 -18.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M63.654,26.056A4.858,4.858,0,0,1,62.476,29.5a3.447,3.447,0,0,1-2.621,1.126,2.621,2.621,0,0,1-2.428-1.214h-.036v4.5h-1.9V24.7q0-1.371-.07-2.815h1.671l.106,1.355h.036a3.38,3.38,0,0,1,5.409-.335A4.71,4.71,0,0,1,63.654,26.056Zm-1.935.069a3.52,3.52,0,0,0-.563-2.058,1.945,1.945,0,0,0-1.654-.845,1.975,1.975,0,0,0-1.275.466,2.161,2.161,0,0,0-.748,1.223,2.487,2.487,0,0,0-.088.579v1.426a2.284,2.284,0,0,0,.572,1.575,1.9,1.9,0,0,0,1.486.642,1.945,1.945,0,0,0,1.671-.827A3.639,3.639,0,0,0,61.719,26.126Z",
    transform: "translate(-43.829 -18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M74.692,26.056a4.855,4.855,0,0,1-1.18,3.447,3.443,3.443,0,0,1-2.62,1.126,2.619,2.619,0,0,1-2.427-1.214h-.036v4.5h-1.9V24.7q0-1.371-.07-2.815H68.13l.106,1.355h.036a3.381,3.381,0,0,1,5.41-.335A4.724,4.724,0,0,1,74.692,26.056Zm-1.935.069a3.52,3.52,0,0,0-.564-2.058,1.942,1.942,0,0,0-1.653-.845,1.978,1.978,0,0,0-1.276.466,2.16,2.16,0,0,0-.747,1.223,2.536,2.536,0,0,0-.088.579v1.426A2.291,2.291,0,0,0,69,28.492a1.9,1.9,0,0,0,1.488.642,1.945,1.945,0,0,0,1.671-.827A3.639,3.639,0,0,0,72.756,26.126Z",
    transform: "translate(-45.032 -18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M87.139,26.707a3.16,3.16,0,0,1-1.053,2.463,4.668,4.668,0,0,1-3.23,1.038,5.654,5.654,0,0,1-3.073-.739l.44-1.583a5.207,5.207,0,0,0,2.746.757,2.6,2.6,0,0,0,1.672-.485,1.583,1.583,0,0,0,.6-1.3,1.652,1.652,0,0,0-.493-1.215,4.58,4.58,0,0,0-1.636-.917Q80,23.569,80,21.331a3.009,3.009,0,0,1,1.091-2.4,4.3,4.3,0,0,1,2.9-.934,5.755,5.755,0,0,1,2.691.563l-.475,1.549a4.669,4.669,0,0,0-2.269-.545,2.3,2.3,0,0,0-1.565.493,1.408,1.408,0,0,0-.475,1.074,1.449,1.449,0,0,0,.544,1.161,6.153,6.153,0,0,0,1.725.915,5.852,5.852,0,0,1,2.251,1.442A3.012,3.012,0,0,1,87.139,26.707Z",
    transform: "translate(-46.485 -18.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M94.451,23.073H92.357v4.151q0,1.584,1.108,1.583a3.378,3.378,0,0,0,.844-.088l.053,1.442a4.3,4.3,0,0,1-1.477.21,2.279,2.279,0,0,1-1.76-.686,3.37,3.37,0,0,1-.633-2.3v-4.31H89.244V21.646h1.247V20.08l1.866-.563v2.129h2.094Z",
    transform: "translate(-47.516 -18.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M104.666,26.091a4.69,4.69,0,0,1-1.126,3.237,4.021,4.021,0,0,1-3.133,1.3,3.823,3.823,0,0,1-3-1.248,4.546,4.546,0,0,1-1.117-3.149,4.644,4.644,0,0,1,1.152-3.254,3.987,3.987,0,0,1,3.1-1.267,3.9,3.9,0,0,1,3.026,1.249A4.494,4.494,0,0,1,104.666,26.091Zm-1.971.061a3.846,3.846,0,0,0-.51-2.029A1.876,1.876,0,0,0,100.48,23.1a1.9,1.9,0,0,0-1.742,1.023,3.919,3.919,0,0,0-.51,2.064,3.84,3.84,0,0,0,.51,2.028,1.941,1.941,0,0,0,3.43-.018A3.859,3.859,0,0,0,102.7,26.153Z",
    transform: "translate(-48.285 -18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M112.061,23.557a3.3,3.3,0,0,0-.6-.053,1.8,1.8,0,0,0-1.549.757,2.847,2.847,0,0,0-.475,1.688v4.486h-1.9l.018-5.857q0-1.478-.071-2.692h1.655l.069,1.636h.053a2.924,2.924,0,0,1,.95-1.354,2.3,2.3,0,0,1,1.373-.458,3.05,3.05,0,0,1,.475.035Z",
    transform: "translate(-49.505 -18.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M121.226,25.755a4.456,4.456,0,0,1-.069.862h-5.7a2.48,2.48,0,0,0,.827,1.936,2.823,2.823,0,0,0,1.864.6,6.3,6.3,0,0,0,2.306-.4l.3,1.319a7.129,7.129,0,0,1-2.866.528,4.152,4.152,0,0,1-3.124-1.17,4.321,4.321,0,0,1-1.134-3.14,4.9,4.9,0,0,1,1.057-3.219,3.64,3.64,0,0,1,2.989-1.371,3.186,3.186,0,0,1,2.8,1.371A4.624,4.624,0,0,1,121.226,25.755Zm-1.811-.493a2.581,2.581,0,0,0-.369-1.46,1.659,1.659,0,0,0-1.514-.792,1.8,1.8,0,0,0-1.512.774,2.835,2.835,0,0,0-.562,1.477h3.957Z",
    transform: "translate(-50.175 -18.404)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(38.914 5.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M48.464,9.664a2.925,2.925,0,0,1-.943,2.368,3.749,3.749,0,0,1-2.48.734,11.5,11.5,0,0,1-1.366-.069V6.967a10.079,10.079,0,0,1,1.608-.121,3.467,3.467,0,0,1,2.308.666A2.69,2.69,0,0,1,48.464,9.664Zm-.985.026a2.129,2.129,0,0,0-.54-1.565,2.128,2.128,0,0,0-1.578-.544,3.952,3.952,0,0,0-.752.061V12a4.93,4.93,0,0,0,.631.026,2.209,2.209,0,0,0,1.655-.6A2.387,2.387,0,0,0,47.48,9.69Z",
    transform: "translate(-43.676 -6.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M54.406,10.774a2.3,2.3,0,0,1-.553,1.59,1.975,1.975,0,0,1-1.539.64,1.877,1.877,0,0,1-1.474-.614,2.236,2.236,0,0,1-.548-1.547,2.281,2.281,0,0,1,.566-1.6,1.962,1.962,0,0,1,1.525-.622,1.921,1.921,0,0,1,1.487.613A2.218,2.218,0,0,1,54.406,10.774Zm-.968.03a1.9,1.9,0,0,0-.25-1,.922.922,0,0,0-.838-.5.937.937,0,0,0-.856.5,1.925,1.925,0,0,0-.25,1.014,1.9,1.9,0,0,0,.25,1,.942.942,0,0,0,.847.5.932.932,0,0,0,.838-.511A1.888,1.888,0,0,0,53.437,10.8Z",
    transform: "translate(-44.397 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M62.02,8.719l-1.314,4.2h-.855L59.306,11.1a13.649,13.649,0,0,1-.338-1.357h-.017a9.935,9.935,0,0,1-.338,1.357l-.578,1.824h-.865l-1.236-4.2h.96l.475,2q.172.708.285,1.348h.017q.1-.527.347-1.339l.6-2h.761l.571,1.962q.207.718.337,1.383h.026a13.213,13.213,0,0,1,.285-1.383L61.1,8.72h.917Z",
    transform: "translate(-45.013 -6.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M67.747,12.908h-.934V10.5q0-1.112-.846-1.112a.843.843,0,0,0-.674.306,1.084,1.084,0,0,0-.259.72v2.491H64.1v-3q0-.553-.034-1.2h.821l.044.657h.026a1.349,1.349,0,0,1,.484-.507,1.578,1.578,0,0,1,.846-.236,1.34,1.34,0,0,1,.977.38,1.849,1.849,0,0,1,.484,1.392Z",
    transform: "translate(-45.899 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M70.974,12.683h-.933V6.556h.933Z",
    transform: "translate(-46.551 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M76.755,10.774a2.3,2.3,0,0,1-.553,1.59,1.976,1.976,0,0,1-1.539.64,1.874,1.874,0,0,1-1.474-.614,2.236,2.236,0,0,1-.548-1.547,2.281,2.281,0,0,1,.566-1.6,1.962,1.962,0,0,1,1.524-.622,1.923,1.923,0,0,1,1.488.613A2.217,2.217,0,0,1,76.755,10.774Zm-.969.03a1.9,1.9,0,0,0-.25-1,.921.921,0,0,0-.837-.5.935.935,0,0,0-.856.5,1.925,1.925,0,0,0-.25,1.014,1.9,1.9,0,0,0,.25,1,.942.942,0,0,0,.847.5.93.93,0,0,0,.837-.511A1.88,1.88,0,0,0,75.785,10.8Z",
    transform: "translate(-46.834 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M81.908,12.909H81.07L81,12.425h-.026A1.438,1.438,0,0,1,79.747,13a1.266,1.266,0,0,1-.959-.38,1.193,1.193,0,0,1-.329-.855,1.3,1.3,0,0,1,.644-1.175,3.343,3.343,0,0,1,1.811-.4v-.078q0-.83-.872-.829a1.953,1.953,0,0,0-1.095.311l-.19-.613A2.693,2.693,0,0,1,80.2,8.623q1.647,0,1.648,1.737v1.547A6.561,6.561,0,0,0,81.908,12.909Zm-.969-1.443v-.648q-1.545-.027-1.545.846a.633.633,0,0,0,.179.493.653.653,0,0,0,.456.164.943.943,0,0,0,.571-.194.8.8,0,0,0,.339-.661Z",
    transform: "translate(-47.468 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M87.794,12.683h-.829l-.044-.674H86.9a1.4,1.4,0,0,1-1.349.77,1.581,1.581,0,0,1-1.262-.6,2.322,2.322,0,0,1-.5-1.547,2.435,2.435,0,0,1,.544-1.651,1.674,1.674,0,0,1,1.3-.588,1.259,1.259,0,0,1,1.183.57h.018V6.556h.935v5Q87.761,12.165,87.794,12.683Zm-.968-1.771v-.7a1.374,1.374,0,0,0-.026-.294,1.063,1.063,0,0,0-.338-.566.918.918,0,0,0-.625-.229.958.958,0,0,0-.821.415,1.779,1.779,0,0,0-.3,1.063A1.659,1.659,0,0,0,85,11.612a.961.961,0,0,0,.816.414.9.9,0,0,0,.738-.346A1.151,1.151,0,0,0,86.827,10.912Z",
    transform: "translate(-48.049 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M96.745,10.774a2.3,2.3,0,0,1-.553,1.59,1.973,1.973,0,0,1-1.539.64,1.88,1.88,0,0,1-1.474-.614,2.236,2.236,0,0,1-.548-1.547,2.281,2.281,0,0,1,.566-1.6,1.963,1.963,0,0,1,1.526-.622,1.919,1.919,0,0,1,1.486.613A2.218,2.218,0,0,1,96.745,10.774Zm-.968.03a1.9,1.9,0,0,0-.25-1,.923.923,0,0,0-.838-.5.939.939,0,0,0-.856.5,1.925,1.925,0,0,0-.25,1.014,1.9,1.9,0,0,0,.25,1,.954.954,0,0,0,1.686-.009A1.9,1.9,0,0,0,95.777,10.8Z",
    transform: "translate(-49.014 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M102.433,12.908H101.5V10.5q0-1.112-.847-1.112a.84.84,0,0,0-.674.306,1.08,1.08,0,0,0-.259.72v2.491h-.935v-3q0-.553-.033-1.2h.82l.044.657h.026a1.363,1.363,0,0,1,.484-.507,1.581,1.581,0,0,1,.847-.236,1.34,1.34,0,0,1,.977.38,1.845,1.845,0,0,1,.484,1.392Z",
    transform: "translate(-49.681 -6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M109.623,9.29h-1.028v2.04c0,.519.183.778.544.778a1.645,1.645,0,0,0,.416-.044l.024.708a2.1,2.1,0,0,1-.725.1,1.116,1.116,0,0,1-.863-.337,1.647,1.647,0,0,1-.312-1.132V9.29h-.614v-.7h.614v-.77l.915-.276V8.59h1.028v.7Z",
    transform: "translate(-50.587 -6.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M115.038,12.683H114.1V10.3q0-1.129-.846-1.13a.891.891,0,0,0-.891.655,1.173,1.173,0,0,0-.044.336v2.526h-.933V6.556h.933V9.087h.018A1.411,1.411,0,0,1,113.6,8.4a1.3,1.3,0,0,1,.96.38,1.913,1.913,0,0,1,.475,1.409Z",
    transform: "translate(-51.059 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M120.75,10.609a2.255,2.255,0,0,1-.035.423h-2.8a1.225,1.225,0,0,0,.405.951,1.391,1.391,0,0,0,.917.294,3.094,3.094,0,0,0,1.132-.2l.146.649a3.516,3.516,0,0,1-1.41.259,2.036,2.036,0,0,1-1.533-.575,2.117,2.117,0,0,1-.557-1.542,2.4,2.4,0,0,1,.519-1.581A1.786,1.786,0,0,1,119,8.614a1.562,1.562,0,0,1,1.373.674A2.242,2.242,0,0,1,120.75,10.609Zm-.891-.241a1.257,1.257,0,0,0-.181-.717.816.816,0,0,0-.743-.389.886.886,0,0,0-.743.38,1.413,1.413,0,0,0-.277.726Z",
    transform: "translate(-51.672 -6.78)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e4e27c5cc509cfa2fe3d25cf8fcfb7e3.svg";
export { ForwardRef as ReactComponent };